module.exports = __webpack_public_path__ + "img/qrimg.d7d41ac1.png";